import React from 'react';
import HeaderLink from '../HeaderLink';
import style from './HeaderButton.module.scss';

export const HamburgerButton = onMobileMenuClick => (
  <button
    aria-label="open menu"
    className={style.menuButton}
    onClick={onMobileMenuClick}
    type="button"
  >
    <div />
    <div />
    <div />
  </button>
);

export const MobileCloseButton = onMobileMenuClick => {
  const props = {
    onClick: onMobileMenuClick,
    className: style.closeButton,
    key: 'headerMobileClose',
    'aria-label': 'close menu',
  };
  return HeaderLink(props);
};
